import { render } from "./LibrariesCreate.vue?vue&type=template&id=56f499ed"
import script from "./LibrariesCreate.vue?vue&type=script&lang=js"
export * from "./LibrariesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__